import { render, staticRenderFns } from "./majorList.vue?vue&type=template&id=69088bd6&scoped=true"
import script from "./majorList.vue?vue&type=script&lang=js"
export * from "./majorList.vue?vue&type=script&lang=js"
import style0 from "./majorList.vue?vue&type=style&index=0&id=69088bd6&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69088bd6",
  null
  
)

export default component.exports